import type * as React from 'react';
import { useDeviceType } from '@cian/ui-kit';
import { useSelector } from 'react-redux';
import {
  buildersWithPhonesSelector,
  isLeadFactorySelector,
  newbuildingIdSelector,
  sellersWithPhonesSelector,
} from '../../selectors/newbuilding';
import { ShowPhonesModal } from '../../components/MobileShowPhonesModal';
import { useCallAnalytics } from '../../hooks/useCallAnalytics';

interface IShowPhonesModalContainerProps {
  isModalOpen: boolean;
  closePhoneModal(): void;
}
export function ShowPhonesModalContainer(props: IShowPhonesModalContainerProps): React.JSX.Element | null {
  const builders = useSelector(buildersWithPhonesSelector);
  const sellers = useSelector(sellersWithPhonesSelector);

  const leadFactorySeller = useSelector(isLeadFactorySelector);
  const newbuildingId = useSelector(newbuildingIdSelector);

  const deviceType = useDeviceType();

  const { trackActionCall } = useCallAnalytics();

  /* istanbul ignore next */
  if (builders.length + sellers.length === 0 && !leadFactorySeller) {
    return null;
  }

  const moreThanOnePhone = builders.length + sellers.length > 1;

  if (moreThanOnePhone || deviceType === 'tablet' || !!leadFactorySeller) {
    return (
      <ShowPhonesModal
        isOpen={props.isModalOpen}
        placeType="main_button"
        newbuildingId={newbuildingId}
        builders={builders}
        sellers={sellers}
        leadFactorySeller={leadFactorySeller}
        trackActionCall={trackActionCall}
        onModalClose={props.closePhoneModal}
      />
    );
  }

  /* istanbul ignore next */
  return null;
}
